import { useEffect, useState } from 'react';

export default function OdemeBasarili() {
  const [sayi, setSayi] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setSayi(s => {
        if (s <= 1) { clearInterval(timer); window.location.href = '/login'; }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#080808', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Syne', sans-serif", padding: 24 }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&display=swap');`}</style>
      <div style={{ textAlign: 'center', maxWidth: 480 }}>
        <div style={{ width: 80, height: 80, borderRadius: '50%', background: 'rgba(34,197,94,0.1)', border: '2px solid rgba(34,197,94,0.3)', margin: '0 auto 24px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36 }}>🎉</div>
        <h1 style={{ fontSize: 32, fontWeight: 800, color: 'white', marginBottom: 12 }}>Ödeme Başarılı!</h1>
        <p style={{ fontSize: 16, color: '#666', marginBottom: 8, lineHeight: 1.7 }}>Hesabınız aktif edildi. Admin panelinize giriş yaparak menünüzü oluşturabilirsiniz.</p>
        <p style={{ fontSize: 13, color: '#444', marginBottom: 32 }}>Aktivasyon maili email adresinize gönderildi.</p>
        <div style={{ background: '#0d0d0d', border: '1px solid #1a1a1a', borderRadius: 16, padding: 20, marginBottom: 24 }}>
          <p style={{ fontSize: 13, color: '#555', marginBottom: 4 }}>{sayi} saniye içinde giriş sayfasına yönlendiriliyorsunuz...</p>
          <div style={{ height: 3, background: '#1a1a1a', borderRadius: 2, overflow: 'hidden' }}>
            <div style={{ height: '100%', background: 'linear-gradient(90deg, #f97316, #ef4444)', borderRadius: 2, transition: 'width 1s linear', width: `${(sayi / 5) * 100}%` }} />
          </div>
        </div>
        <a href="/login" style={{ background: 'linear-gradient(135deg, #f97316, #ef4444)', color: 'white', padding: '14px 32px', borderRadius: 10, textDecoration: 'none', fontWeight: 700, fontSize: 15, display: 'inline-block' }}>
          Admin Panele Git →
        </a>
      </div>
    </div>
  );
}